export default "__VITE_ASSET__DF$NulPF__"